export default __webpack_public_path__ + "static/media/icon-menu-dashboard.dd097804.svg";